import { connect } from "react-redux";
import { IPlayUIStateProps } from "../..";
import {
  sharedMapDispatchToProps,
  sharedMapPropsToState
} from "../Common/Footer.redux";
import {
  IFooterDesktopMapDispatchProps,
  IFooterDesktopMapStateProps
} from "./FooterDesktop";
import { FooterDesktopView } from "./FooterDesktop.view";

const mapStateToProps = (
  state: IPlayUIStateProps
): IFooterDesktopMapStateProps => {
  return sharedMapPropsToState(state);
};

const mapDispatchToProps = (dispatch): IFooterDesktopMapDispatchProps => {
  return sharedMapDispatchToProps(dispatch);
};

export const FooterDesktop: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterDesktopView);
